// utils/inputValidators.js

/**
 * Valida el formato de un input según el tipo de validación
 * @param {string} value - Valor a validar
 * @param {string} validationType - Tipo de validación ('email', 'number', 'text')
 * @returns {boolean} True si es válido, false si no
 */
export const validateInputFormat = (value, validationType) => {
  if (!value || value.trim() === '') return false;

  switch (validationType) {
    case 'email':
      // Regex para validar email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value);

    case 'number':
      // Verificar que solo contenga números
      return /^\d+$/.test(value);

    case 'text':
    default:
      // Para texto, solo verificar que no esté vacío
      return value.trim().length > 0;
  }
};